import axios from "axios";

function AxiosMiddleware(method, url, data, options) {
    axios.defaults.withCredentials = true;
    
    switch (method) {
        case "get":
            return axios.get(url, data, options);
        case "post":
            return axios.post(url, data, options);
        case "head":
            return axios.head(url, data, options);
        case "patch":
            return axios.patch(url, data, options);
        case "put":
            return axios.put(url, data, options);
        case "delete":
            return axios.delete(url, { data: data, headers: options });
    }
}

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export function get(url, data = [], options = {}) {
    return AxiosMiddleware("get", url, data, options);
}
export function post(url, data = [], options = {}) {
    return AxiosMiddleware("post", url, data, options);
}
export function head(url, data = [], options = {}) {
    return AxiosMiddleware("head", url, data, options);
}
export function patch(url, data = [], options = {}) {
    return AxiosMiddleware("patch", url, data, options);
}
export function put(url, data = [], options = {}) {
    return AxiosMiddleware("put", url, data, options);
}
export function del(url, data = [], options = {}) {
    return AxiosMiddleware("delete", url, data, options);
}

